module.exports = __webpack_public_path__ + "img/vpc13.79f3914.png";